import { render, staticRenderFns } from "./base-demo-flow.vue?vue&type=template&id=5b63d6bc&scoped=true&"
import script from "./base-demo-flow.vue?vue&type=script&lang=js&"
export * from "./base-demo-flow.vue?vue&type=script&lang=js&"
import style0 from "./base-demo-flow.vue?vue&type=style&index=0&id=5b63d6bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63d6bc",
  null
  
)

export default component.exports